import { render, staticRenderFns } from "./HomeCustomSectionBox.vue?vue&type=template&id=6686fc8c&"
import script from "./HomeCustomSectionBox.vue?vue&type=script&lang=js&"
export * from "./HomeCustomSectionBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports